const KNOWN_ASSIGNEE_TYPES = ['AgentBot', 'Captain::Assistant', 'User'];

// Owners that are not people: the inbox's Panel AI bot and its Captain assistant.
export const isAIAssigneeType = assigneeType =>
  assigneeType === 'AgentBot' || assigneeType === 'Captain::Assistant';

export const inferAssigneeType = assignee => {
  if (!assignee?.id) return null;

  if (KNOWN_ASSIGNEE_TYPES.includes(assignee.assignee_type)) {
    return assignee.assignee_type;
  }

  if (
    assignee.role === 'agent_bot' ||
    assignee.bot_type !== undefined ||
    assignee.outgoing_url !== undefined
  ) {
    return 'AgentBot';
  }

  return 'User';
};

export const getConversationAssigneeType = meta => {
  if (!meta?.assignee?.id) return null;

  if (KNOWN_ASSIGNEE_TYPES.includes(meta.assignee_type)) {
    return meta.assignee_type;
  }

  return inferAssigneeType(meta.assignee);
};

export const isHumanAssigneeMeta = meta =>
  getConversationAssigneeType(meta) === 'User';

export const isBotAssigneeMeta = meta =>
  getConversationAssigneeType(meta) === 'AgentBot';

export const isBotHandledConversation = conversation => {
  if (!conversation) return false;
  if (isHumanAssigneeMeta(conversation.meta)) return false;

  return (
    Boolean(conversation.bot_handling) || isBotAssigneeMeta(conversation.meta)
  );
};

export const getInboxBotAgent = agents =>
  (agents || []).find(
    agent =>
      agent.assignee_type === 'AgentBot' ||
      agent.role === 'agent_bot' ||
      agent.bot_type !== undefined ||
      agent.outgoing_url !== undefined
  ) || null;

export const isAgentBotAssigneeMeta = (meta, inboxBotId = null) => {
  const { assignee, assignee_type: assigneeType } = meta || {};
  if (!assignee?.id) return false;

  if (assigneeType === 'AgentBot') {
    return inboxBotId == null || Number(assignee.id) === Number(inboxBotId);
  }

  if (
    assignee.role === 'agent_bot' ||
    assignee.bot_type !== undefined ||
    assignee.outgoing_url !== undefined
  ) {
    return inboxBotId == null || Number(assignee.id) === Number(inboxBotId);
  }

  return false;
};

export const isClearAssigneeSelection = agent =>
  !agent || agent.id === 0 || agent.id === null;

export const isSameAssignee = (left, right) => {
  if (!left?.id || !right?.id) return false;

  return (
    Number(left.id) === Number(right.id) &&
    inferAssigneeType(left) === inferAssigneeType(right)
  );
};

export const isCurrentUserAssigneeMeta = (meta, currentUser) => {
  if (!isHumanAssigneeMeta(meta) || !currentUser?.id) return false;

  return Number(meta.assignee.id) === Number(currentUser.id);
};

export const getAssigneeSelectionKey = assignee => {
  if (!assignee?.id) return 'none';

  return `${inferAssigneeType(assignee)}-${assignee.id}`;
};

export const resolveAssigneeType = assignee =>
  assignee?.assignee_type || inferAssigneeType(assignee);

export const normalizeAssignableAgent = agent => {
  if (!agent) return agent;

  const assignee_type = resolveAssigneeType(agent);
  return assignee_type === agent.assignee_type
    ? agent
    : { ...agent, assignee_type };
};
